import { STOP_LOADING,START_LOADING } from './actionTypes';
  import { getAllLocation, saveLocation, updateLocation, getDeleteLocation,
    getAllPermissionService,
    getAllLocationList,
    getCompanyGroupListService,
    searchLocationListServices,
    getCompanyGroupWithStateServices,
    getCompanyGroupWithoutStateServices
   } from '../../services/locationServices';
import { openSessionTimeoutModal } from './sessionTimeOutActions';


export const saveLocationAction = (formData, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'SAVE_LOCATION' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await saveLocation(formData, token);
    
    dispatch({ type: STOP_LOADING, service: 'SAVE_LOCATION' });
    
    // Trigger callback after saving
    if (response) {
      callbackfn(response);
    }

    dispatch({ type: 'SAVE_LOCATION_SUCCESS', payload: response }); // Dispatch success action
  } catch (error) {
    if (error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'SAVE_LOCATION' });
      dispatch({ type: 'SAVE_LOCATION_FAILURE', payload: error || 'Save location service failed. Please try again.' });
    }
  }
};


    export const updateLocationAction = (formData,callbackfn) => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: 'UPDATE_LOCATION' });
        const token = getState().auth.token || sessionStorage.getItem("token");;
        const response = await updateLocation(formData, token);
        dispatch({ type: STOP_LOADING, service: 'UPDATE_LOCATION' });
        if (response) {
          callbackfn(response);
        }
        dispatch({ type: 'UPDATE_LOCATION_SUCCESS', payload: response });
      } catch (error) {
        dispatch({ type: STOP_LOADING, service: 'UPDATE_LOCATION' });
        dispatch({ type: 'UPDATE_LOCATION_FAILURE', payload: error || 'Update location service failed. Please try again.' });
      }
    };

    export const getAllLocationAction= (page = 0, size = 5) => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: 'ALL_LOCATION' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getAllLocation(token, page, size);
        dispatch({ type: STOP_LOADING, service: 'ALL_LOCATION' });
        dispatch({ type: 'GET_LOCATION_SUCCESS', payload: response });
      } catch (error) {
        dispatch({ type: STOP_LOADING, service: 'ALL_LOCATION' });
          dispatch({ type: 'GET_LOCATION_FAILURE', payload: error || 'All location service failed. Please try again.' });
      }
    };


    export const getDeleteLocationAction = (id, callbackfn) => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        await getDeleteLocation(id, token);
        dispatch({ type: 'DELETE_LOCATION', payload: id });
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    
        if (callbackfn) callbackfn(true, null); 
      } catch (error) {
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    
        const errorData = error?.response?.data || {
          errors: [{
            errorMessage: 'Unable to delete location. Customers are currently assigned to it.\nPlease reassign or remove these customers before deleting.',
            target: null
          }]
        };
    
        dispatch({
          type: 'GET_LOCATION_GROUPS_FAILURE',
          payload: errorData
        });
    
        if (callbackfn) callbackfn(false, errorData);
      }
    };

    export const getAllUserPermissionAction = () => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getAllPermissionService(token);
        dispatch({ type: 'GET_ALL_USER_PERMISSION', payload: response });
        
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      }
      catch (error) {
        dispatch({ type: 'GET_ALL_USER_PERMISSION_FAILURE', payload: error || 'Faile to load user permission. Please try again after some time.' });
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      }
    }

    export const getCompanyListAction = () => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getCompanyGroupListService(token);
        dispatch({ type: 'GET_GROUP_COMPANY_LIST_SUCCESS', payload: response });
        
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      }
      catch (error) {
        dispatch({ type: 'GET_GROUP_COMPANY_LIST_FAILURE', payload: error || 'Faile to load user permission. Please try again after some time.' });
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
      }
    }

     export const getAllLocationListAction= (page = 0, size = 5) => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getAllLocationList(token, page, size);
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        dispatch({ type: 'GET_LOCATION_LIST_SUCCESS', payload: response });
      } catch (error) {
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
          dispatch({ type: 'GET_LOCATION_LIST_FAILURE', payload: error || 'All location service failed. Please try again.' });
      }
    };

  export const searchLocationListAction = (keyword, page = 0, size = 5) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await searchLocationListServices(keyword, token, page, size);
    dispatch({ type: 'GET_SEARCH_LOCATION_LIST_SUCCESS', payload: response});
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
  } catch (error) {
    dispatch({ type: 'GET_SEARCH_LOCATION_LIST_FAILURE', error,});
  }
};

export const getCompanyGroupWithStateAction = (stateCode) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getCompanyGroupWithStateServices(stateCode, token);
    dispatch({ type: 'GET_STATE_CODE_LIST_SUCCESS', payload: response,});
    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
  } catch (error) {
    dispatch({ type: 'GET_STATE_CODE_LIST_FAILURE', payload:error,});
  }
};

export const getCompanyGroupWithoutStateAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getCompanyGroupWithoutStateServices(token);
    dispatch({ type: 'GET_CARRIER_LIST_SUCCESS', payload: response,
    });
  } catch (error) {
    dispatch({ type: 'GET_CARRIER_LIST_FAILURE', payload:error,});
  }
};

